import React, {useEffect, useState} from 'react';
import "./ClientsCRUD.scss"
import styles from "./ClientsCRUD.module.scss"
import ClientCard from "./components/ClientCard";
import {useAppDispatch, useAppSelector} from "../../../hooks/hooks";
import { getClients } from "./ClientsCRUD.slice";
import {Button, Input} from "semantic-ui-react";
import NewClientForm from "./ClientsCRUD.form";
import { IClient } from "./ClientsCRUD.types";
import {buildQueryString} from "../../../helpers/buildQueryString";
import {useDebounce} from "../../../hooks/useDebounce";

const ClientsCRUD = () => {
    const dispatch = useAppDispatch()
    const { allClients } = useAppSelector(state => state.ClientsCRUD)
    const [searchWord, setSearchWord] = useState("");
    const [isOpenForm, setIsOpenForm] = useState(false);
    const [editedClient, setEditedClient] = useState<IClient | null>(null);

    useEffect(() => {
        dispatch(getClients(""))
    }, [dispatch]);

    const onSetEditedClient = (client:IClient) => {
        setEditedClient(client)
        setIsOpenForm(true)
    }

    const onSearch = () => {
        dispatch(getClients(buildQueryString({search:searchWord})))
    }

    useDebounce(onSearch,searchWord,500)

    return (
        <div className="cms-container-general">
            <div className={styles.controls}>
                <Input
                    defaultValue={""}
                    value={searchWord}
                    onChange={(e) => setSearchWord(e.target.value)}
                    icon='search'
                    placeholder='Search...'
                />
                <Button
                    onClick={() => setIsOpenForm(true)}
                    color="blue"
                    id="add_game"
                >
                    Add
                </Button>
            </div>
            <div className={styles.cards}>
                {allClients.map(client => {
                    return (
                        <ClientCard
                            key={client.id as number}
                            setEditedClient={onSetEditedClient}
                            client={client}
                        />
                    )
                })}
            </div>
            {isOpenForm &&
                <NewClientForm
                    editedClient={editedClient}
                    closeForm={() => {
                        setIsOpenForm(false)
                        setEditedClient(null)
                    }
                }
                />
            }
        </div>
    );
};

export default ClientsCRUD;
